import React from "react";

const Footer = ({ setCurrentPage }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo" onClick={() => setCurrentPage("home")}>
              <h3>Laiger</h3>
              <p>Premium Clothing Manufacturing</p>
            </div>
            <p className="footer-description">
              Crafting exceptional jeans, shirts, t-shirts, sweaters, and
              jackets with sustainable practices and unparalleled attention to
              detail.
            </p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li>
                <button onClick={() => setCurrentPage("home")}>Home</button>
              </li>
              <li>
                <button onClick={() => setCurrentPage("about")}>
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => setCurrentPage("contact")}>
                  Contact Us
                </button>
              </li>
              <li>
                <button onClick={() => setCurrentPage("privacy")}>
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Our Products</h4>
            <ul>
              <li>Premium Jeans</li>
              <li>Casual Shirts</li>
              <li>T-Shirts</li>
              <li>Sweaters & Knits</li>
              <li>Jackets & Outerwear</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Connect With Us</h4>
            <div className="footer-social">
              <a href="#" className="social-link">
                Instagram
              </a>
              <a href="#" className="social-link">
                LinkedIn
              </a>
              <a href="#" className="social-link">
                Pinterest
              </a>
              <a href="#" className="social-link">
                YouTube
              </a>
            </div>
            <div className="newsletter">
              <p>Subscribe for updates</p>
              <div className="newsletter-form">
                <input type="email" placeholder="Your email" />
                <button type="submit">→</button>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {currentYear} Laiger Clothing. All rights reserved. | Crafted
            with care in New York
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
